export default __webpack_public_path__ + "static/media/imagem_04.134dc5b1.jpeg";